export default __webpack_public_path__ + "static/media/Risk_Management_Policy_2.1e74dc4e.pdf";